<template>
	<div :class="{ 'hidden': hidden }" class="pagination-container">
		<el-pagination :background="background" :current-page="currentPage" :page-size="pageSize" :layout="layout"
			:page-sizes="pageSizes" :pager-count="pagerCount" :total="total" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script setup>
	// import { scrollTo } from '@/utils/scroll-to'

	const props = defineProps({
		total: {
			required: true,
			type: Number
		},
		page: {
			type: Number,
			default: 1
		},
		pageSize: {
			type: Number,
			default: 20
		},
		pageSizes: {
			type: Array,
			default () {
				return [20, 50, 100]
			}
		},
		// 移动端页码按钮的数量端默认值5
		pagerCount: {
			type: Number,
			default: 5 // 5-21之间 document.body.clientWidth < 992 ? 5 : 7
		},
		layout: {
			type: String,
			default: 'prev, pager, next, sizes, jumper'
			// default: 'total, sizes, prev, pager, next, jumper'
		},
		background: {
			type: Boolean,
			default: false
		},
		autoScroll: {
			type: Boolean,
			default: true
		},
		hidden: {
			type: Boolean,
			default: false
		}
	})

	const emit = defineEmits()
	const currentPage = computed({
		get() {
			return props.page
		},
		set(val) {
			emit('update:page', val)
		}
	})
	const pageSizeNew = computed({
		get() {
			return props.pageSize
		},
		set(val) {
			emit('update:pageSize', val)
		}
	})

	function handleSizeChange(val) {
		if (currentPage.value * val > props.total) {
			currentPage.value = 1
		}
		emit('pagination', {
			page: currentPage.value,
			pageSize: val
		})
		// if (props.autoScroll) {
		//   scrollTo(0, 800)
		// }
	}

	function handleCurrentChange(val) {
		emit('pagination', {
			page: val,
			pageSize: pageSizeNew.value
		})
		// if (props.autoScroll) {
		//   scrollTo(0, 800)
		// }
	}
</script>

<style scoped>
	.pagination-container.hidden {
		display: none;
	}
</style>